export default __webpack_public_path__ + "static/media/1527.c88bdab6.png";